import { createIcon } from "@chakra-ui/react";

export const BookClosed = createIcon({
  displayName: "BookClosed",
  viewBox: "0 0 24 24",
  d: "M20.116 4.377 16.824.878A2.754 2.754 0 0 0 14.826 0H6.824C5.264 0 4 1.343 4 3v18c0 1.657 1.264 3 2.824 3h11.294c1.553 0 2.823-1.35 2.823-3V6.497a3.1 3.1 0 0 0-.825-2.12zM18.823 21c0 .414-.316.75-.705.75H6.824c-.39 0-.705-.336-.705-.75L6.118 3.006c0-.414.316-.75.706-.75h7.058V6c0 .828.633 1.5 1.412 1.5h3.49V21h.04zM8.236 13.125c0 .623.477 1.125 1.06 1.125h6.352c.587 0 1.059-.502 1.059-1.125S16.234 12 15.647 12H9.294c-.582 0-1.059.506-1.059 1.125zm7.412 3.375H9.294c-.582 0-1.059.506-1.059 1.125s.475 1.125 1.06 1.125h6.352c.585 0 1.059-.504 1.059-1.125s-.472-1.125-1.059-1.125z",
  defaultProps: {
    "aria-label": "A symbolic sheet of paper with lines within"
  }
});

export default BookClosed;
